import React, { useEffect, useState } from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';
import { LuPlus } from "react-icons/lu";
import { createRole, DeleteRoleId, getallRole } from '../../../api/api';
import toast from 'react-hot-toast';
import { generateRandomObjectId } from '../../../utils';  // Import the utility

const Role = () => {
  const [roleOptions, setRoleOptions] = useState([]);
  const [newRoleName, setNewRoleName] = useState('');

  // Add new role with generated _id
  const addNewRole = () => {
    const newRole = {
      _id: generateRandomObjectId(), // Generate a random ObjectID-like _id
      role: newRoleName,
    };
    setRoleOptions((prevOptions) => [...prevOptions, newRole]);
    setNewRoleName(''); // Clear input after adding
  };

  // Update role name by id
  const handleRoleNameChange = (id, role) => {
    setRoleOptions((prevOptions) =>
      prevOptions.map((r) =>
        r._id === id ? { ...r, role } : r
      )
    );
  };

  // Delete role by id
  const handleDeleteRole = (id) => {
    setRoleOptions((prevOptions) => prevOptions.filter((role) => role._id !== id));
    DeleteRoleId(id).then((res) => toast.success(res.message));
  };

  // Submit all role options to the server
  const handleSubmit = async () => {
    const data = await createRole({ roles: roleOptions });
    toast.success(data.message);
    console.log("Submitted Data:", data);
  };

  // Fetch all roles when the component mounts
  useEffect(() => {
    getallRole().then((data) => {
      setRoleOptions(data.data);
    });
  }, []);

  return (
    <div className="p-4 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6">Roles</h1>

      <div className="flex w-full lg:w-6/6 xl:w-4/4 mx-auto">
        <div className="grid grid-cols-3 gap-4 w-full">
          {roleOptions.map((roleOption, index) => (
            <div key={index} className="relative flex flex-col w-full">
              <label htmlFor={`role-${roleOption._id}`} className="block mb-1 text-sm font-medium text-gray-700">
                Role
              </label>
              <input
                id={`role-${index}`}
                type="text"
                value={roleOption.role}
                onChange={(e) => handleRoleNameChange(roleOption._id, e.target.value)}
                className="w-full px-3 py-2 border rounded-md outline-none"
              />
              {index > 2 && (
                <button
                  onClick={() => handleDeleteRole(roleOption._id)}
                  className="absolute top-0 right-0 p-1 text-gray-900 hover:text-gray-700"
                >
                  <TrashIcon className="w-4 h-4" />
                </button>
              )}
            </div>
          ))}
        </div>

        <div className="relative flex flex-col w-1/6 justify-start ml-4 p-3">
          <button
            onClick={addNewRole}
            className="mt-2 flex items-center justify-center border-2 border-dashed border-gray-300 rounded-full w-12 h-12 text-gray-500 hover:text-gray-700 hover:border-gray-400 transition-colors duration-200"
          >
            <LuPlus className="w-6 h-6" />
          </button>
        </div>
      </div>

      <div className="col-span-3 text-center mt-6">
        <button
          type="submit"
          onClick={handleSubmit}
          className="w-full py-3 px-4 bg-black text-white font-semibold rounded-md shadow focus:ring focus:ring-opacity-75 focus:ring-black"
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default Role;
